var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84961 13.25H3.09961C2.70178 13.25 2.32025 13.092 2.03895 12.8107C1.75764 12.5294 1.59961 12.1478 1.59961 11.75V4.25C1.59961 3.85218 1.75764 3.47064 2.03895 3.18934C2.32025 2.90804 2.70178 2.75 3.09961 2.75H15.0996C15.4974 2.75 15.879 2.90804 16.1603 3.18934C16.4416 3.47064 16.5996 3.85218 16.5996 4.25V11.75C16.5996 12.1478 16.4416 12.5294 16.1603 12.8107C15.879 13.092 15.4974 13.25 15.0996 13.25H14.3496",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09961 11.75L12.8496 16.25H5.34961L9.09961 11.75Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon01);
export default __webpack_public_path__ + "static/media/lesson-icon-01.65f4e3738259c59030d8bd0b3eaa047e.svg";
export { ForwardRef as ReactComponent };